module.exports = __webpack_public_path__ + "PY.png?98ce0d64abc29d8b2632ff5a9f3a4ec4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/PY.png
// module id = 399
// module chunks = 0